import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatetime = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .4,
			d: "M0 3.5V5H13.8272V3.5C13.8272 2.67188 13.1636 2 12.3457 2H10.8642V1C10.8642 0.446875 10.4228 0 9.87654 0C9.33025 0 8.88889 0.446875 8.88889 1V2H4.93827V1C4.93827 0.446875 4.49691 0 3.95062 0C3.40432 0 2.96296 0.446875 2.96296 1V2H1.48148C0.66358 2 0 2.67188 0 3.5ZM0 6V14.5C0 15.3281 0.66358 16 1.48148 16H10.2099C8.81481 15.0031 7.90123 13.3594 7.90123 11.5C7.90123 8.4625 10.3333 6 13.3333 6H0ZM13.3333 6C13.5 6 13.6636 6.00625 13.8272 6.02187V6H13.3333Z",
			fill: "url(#paint0_linear_7940_104545)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3334 16C14.5121 16 15.6426 15.5259 16.4761 14.682C17.3096 13.8381 17.7778 12.6935 17.7778 11.5C17.7778 10.3065 17.3096 9.16193 16.4761 8.31802C15.6426 7.47411 14.5121 7 13.3334 7C12.1546 7 11.0242 7.47411 10.1907 8.31802C9.35717 9.16193 8.88892 10.3065 8.88892 11.5C8.88892 12.6935 9.35717 13.8381 10.1907 14.682C11.0242 15.5259 12.1546 16 13.3334 16ZM13.8272 9.5V11H14.8148C15.0864 11 15.3087 11.225 15.3087 11.5C15.3087 11.775 15.0864 12 14.8148 12H13.3334C13.0618 12 12.8395 11.775 12.8395 11.5V9.5C12.8395 9.225 13.0618 9 13.3334 9C13.605 9 13.8272 9.225 13.8272 9.5Z",
			fill: "url(#paint1_linear_7940_104545)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_7940_104545",
			x1: 0,
			y1: 8,
			x2: 13.8272,
			y2: 8,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_7940_104545",
			x1: 8.88892,
			y1: 11.5,
			x2: 17.7778,
			y2: 11.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#1D7FB6" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#01D5AB"
			})]
		})] })
	]
});
export { SvgDatetime as ReactComponent };
